/**
 * Writes, deletes profile data for us to be able to fake API access.
 */
function createProfileKey(userId) {
  return `mock_${userId}`;
}

export const get = userId => {
  const key = createProfileKey(userId);
  const profile = window.sessionStorage.getItem(key);
  if (!profile) {
    return false;
  }
  return JSON.parse(profile);
};
